import Spinner from "../Loading/Spinner";
import { RxCross2 } from "react-icons/rx";
import { useNavigate, Link, NavLink } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { UserSignUp } from "../../redux/actions/User";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "notiflix/build/notiflix-loading-aio";
import { HiOutlineUser } from "react-icons/hi2";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { HiOutlineEnvelope } from "react-icons/hi2";
import { HiOutlinePhone } from "react-icons/hi2";
import { HiOutlineLockClosed, HiOutlineEye, HiOutlineEyeSlash } from "react-icons/hi2";
import { IoArrowBack } from "react-icons/io5";
import "./Signup.css";
import { miloAnonId } from "../../utils/metaPixel";

const SignupBox = ({ isModalLogin = false, setModalShow, setActive }) => {
    const [user, setUser] = useState({
        firstName: "",
        lastName: "",
        organizationName: "",
        email: "",
        phoneNumber: "",
        password: "",
        confirmPassword: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false);
    const [passwordValidation, setPasswordValidation] = useState({
        minLength: false,
        hasUppercase: false,
        hasNumber: false,
    });

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handlechange = (e) => {
        const { name, value } = e.target;
        setUser((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));

        // Validate password on change
        if (name === "password") {
            setPasswordValidation({
                minLength: value.length >= 8,
                hasUppercase: /[A-Z]/.test(value),
                hasNumber: /[0-9]/.test(value),
            });
        }
    };

    const dataSubmit = (e) => {
        e.preventDefault();
        
        // Validate password requirements
        if (!passwordValidation.minLength || !passwordValidation.hasUppercase || !passwordValidation.hasNumber) {
            return;
        }
        
        // Validate password match
        if (user.password !== user.confirmPassword) {
            return;
        }
        
        // Validate terms agreement
        if (!agreeTerms) {
            return;
        }

        const formdata = new FormData();
        formdata.append("firstName", user.firstName);
        formdata.append("lastName", user.lastName);
        formdata.append("organizationName", user.organizationName);
        formdata.append("email", user.email);
        formdata.append("phoneNumber", user.phoneNumber);
        formdata.append("password", user.password);
        const anon = miloAnonId();
        if (anon) formdata.append("milo_anon_id", anon);
        dispatch(UserSignUp(formdata, navigate, isModalLogin, setActive, setModalShow));
    };

    const isLoading = useSelector((state) => state.user.isLoading);
    
    useEffect(() => {
        if (isLoading === true) {
            Loading.standard("Loading Please Wait", {
                svgColor: "#CD292E",
            });
        } else {
            Loading.remove();
        }
    }, [isLoading]);

    const handelNavigate = () => {
        if (isModalLogin) {
            setActive(1);
        } else {
            navigate("/login" + window.location.search);
        }
    };

    return (
        <div className="signup-box">
            {isModalLogin ? (
                <RxCross2
                    onClick={() => setModalShow(false)}
                    className="text-[23px] float-right hover:text-[#CD292E] cursor-pointer"
                />
            ) : (
                <NavLink to="/" className="back-to-home">
                    <IoArrowBack />
                    <span>Back to Home</span>
                </NavLink>
            )}
            
            {/* Logo */}
            <div className="signup-logo">
                <span className="logo-insta">INSTA</span>
                <span className="logo-pass">PASS</span>
            </div>

            {/* Header */}
            <h1 className="signup-title">Create Your Account</h1>
            <p className="signup-subtitle">One account for tickets, hosting your own events and Creator Partners.</p>

            <form onSubmit={dataSubmit}>
                {/* Name Fields */}
                <div className="form-row">
                    <div className="input-group">
                        <label className="input-label">First Name</label>
                        <div className="input-wrapper">
                            <HiOutlineUser className="input-icon" />
                            <input
                                type="text"
                                name="firstName"
                                value={user.firstName}
                                onChange={handlechange}
                                placeholder="John"
                                className="signup-input"
                                autoComplete="off"
                                required
                            />
                        </div>
                    </div>
                    <div className="input-group">
                        <label className="input-label">Last Name</label>
                        <div className="input-wrapper">
                            <input
                                type="text"
                                name="lastName"
                                value={user.lastName}
                                onChange={handlechange}
                                placeholder="Doe"
                                className="signup-input"
                                autoComplete="off"
                                required
                            />
                        </div>
                    </div>
                </div>


                {/* Email */}
                <div className="input-group">
                    <label className="input-label">Email Address</label>
                    <div className="input-wrapper">
                        <HiOutlineEnvelope className="input-icon" />
                        <input
                            type="email"
                            name="email"
                            value={user.email}
                            onChange={handlechange}
                            placeholder="your@email.com"
                            className="signup-input"
                            autoComplete="off"
                            required
                        />
                    </div>
                </div>

                {/* Phone Number */}
                <div className="input-group">
                    <label className="input-label">Mobile Number</label>
                    <div className="input-wrapper">
                        <HiOutlinePhone className="input-icon" />
                        <input
                            type="tel"
                            name="phoneNumber"
                            value={user.phoneNumber}
                            onChange={handlechange}
                            placeholder="+1 (555) 000-0000"
                            className="signup-input"
                            autoComplete="off"
                            required
                        />
                    </div>
                </div>

                {/* Password Fields */}
                <div className="form-row">
                    <div className="input-group">
                        <label className="input-label">Password</label>
                        <div className="input-wrapper">
                            <HiOutlineLockClosed className="input-icon" />
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={user.password}
                                onChange={handlechange}
                                placeholder="Create password"
                                className="signup-input"
                                autoComplete="off"
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <HiOutlineEyeSlash /> : <HiOutlineEye />}
                            </button>
                        </div>
                    </div>
                    <div className="input-group">
                        <label className="input-label">Confirm Password</label>
                        <div className="input-wrapper">
                            <HiOutlineLockClosed className="input-icon" />
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirmPassword"
                                value={user.confirmPassword}
                                onChange={handlechange}
                                placeholder="Confirm password"
                                className="signup-input"
                                autoComplete="off"
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                {showConfirmPassword ? <HiOutlineEyeSlash /> : <HiOutlineEye />}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Password Requirements */}
                <div className="password-requirements">
                    <p className="requirements-title">Password must contain:</p>
                    <ul className="requirements-list">
                        <li className={passwordValidation.minLength ? "valid" : ""}>
                            At least 8 characters
                        </li>
                        <li className={passwordValidation.hasUppercase ? "valid" : ""}>
                            One uppercase letter
                        </li>
                        <li className={passwordValidation.hasNumber ? "valid" : ""}>
                            One number
                        </li>
                    </ul>
                </div>

                {/* Terms Checkbox */}
                <div className="terms-section">
                    <label className="terms-checkbox">
                        <input
                            type="checkbox"
                            checked={agreeTerms}
                            onChange={(e) => setAgreeTerms(e.target.checked)}
                        />
                        <span className="checkmark"></span>
                        <span className="terms-text">
                            I agree to the{" "}
                            <Link to="/terms" className="terms-link">Terms of Service</Link>
                            {" "}and{" "}
                            <Link to="/privacy" className="terms-link">Privacy Policy</Link>
                        </span>
                    </label>
                </div>

                {/* Submit Button */}
                <button
                    type="submit"
                    className={`create-account-btn ${isLoading ? "loading" : ""}`}
                    disabled={isLoading || !agreeTerms}
                >
                    {isLoading ? <Spinner /> : "Create Account"}
                </button>

                {/* Sign In Link */}
                <p className="signin-link-text">
                    Already have an account?{" "}
                    <span onClick={handelNavigate}>Sign in</span>
                </p>
            </form>
        </div>
    );
};

export default SignupBox;
